export function getRouteParams(event) {
    return { name: 'event-info-categories', id: event?.id };
}
